import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Sidebar.scss'
import Sidebar from './Sidebar'
import { ErrorPlaceholderBox, withErrorBoundary } from '../general/util/ErrorBoundaries'
import Newsletter from '../general/newsletter/Newsletter'
import { AdsForDesktop, AdsForMobile, AdSlotMob2, AdSlotRectangle2, AdSlotSkyscraper1 } from '../general/ads/Ads'
import some from 'lodash/some'
import track from 'react-tracking'
import NoAdBlocker from '../widgets/NoAdBlocker'
import Breakpoint from '@otavamedia/om-component-library/lib/util/Breakpoint'
import WhyOrder from '../widgets/WhyOrder'
import { breakpoints } from '@otavamedia/om-component-library/lib/lib/utils'

@track({ gtmContext: ['IndexSidebar'] })
class IndexSidebar extends Component {
  loaded = {
    sidebar2: false,
  }

  constructor (props) {
    super(props)
    this.shouldReload = true
  }

  UNSAFE_componentWillReceiveProps (props) {
    this.loaded = {
      sidebar2: false,
    }
  }

  doneLoading (element) {
    this.loaded[element] = true
    if (!some(Object.values(this.loaded), (x) => !x)) {
      this.props.doneLoading()
    }
  }

  render () {
    const { blocks, categoryId, error } = this.props
    if (error) {
      throw error
    }
    return (
      <Sidebar category={categoryId} {...blocks} articles doneLoading={() => this.doneLoading('sidebar2')}>
        <Breakpoint minBreakpoint={breakpoints.sm}>
          <WhyOrder/>
        </Breakpoint>
        <AdsForDesktop>
          <Newsletter showAlways={true}/>
          <AdSlotRectangle2 debugName="index-main-sidebar" fallBackElements={[NoAdBlocker]} />
          <AdSlotSkyscraper1 fallBackElements={[NoAdBlocker]} />
        </AdsForDesktop>
        <AdsForMobile>
          <AdSlotMob2 fallBackElements={[NoAdBlocker]} />
          <Newsletter showAlways={true}/>
        </AdsForMobile>
      </Sidebar>
    )
  }
}

IndexSidebar.propTypes = {
  status: PropTypes.number,
  wait: PropTypes.bool,
  categoryId: PropTypes.number,
  items: PropTypes.array,
  isReady: PropTypes.bool,
  blocks: PropTypes.object,
  error: PropTypes.object,
  doneLoading: PropTypes.func,
}

IndexSidebar.defaultProps = {
  wait: false,
  blocks: {},
}

export default withErrorBoundary(
  IndexSidebar,
  ErrorPlaceholderBox('Sisältöä ei saatu ladattua')
)
